/* UserFeedbackRenderer.js */

"use strict";

class UserFeedbackRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("modal-user-feedback-gl");
        this._rootElem.component = this._model;

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
    }

    _unregisterListeners() {
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        let promArr = [Promise.resolve()];

        return Promise.all(promArr)
            .then(() => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            });
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve/*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._model._veil.renderer.rootElement);
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    //TODO Private Render Methods here

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = UserFeedbackRenderer;